import * as React from 'react';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import ErrorIcon from 'assets/images/error.react.svg';
import { NoteContent } from 'view/layout/note-content';
import { multiple as gridMultiple } from 'view/styles/grid';
import { h600 } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
import { ScreenName } from '@atlassian/help-center-common-component/constants';
import { ThemedButton } from '@atlassian/help-center-common-component/themed-button';
import { AnalyticsScreen } from '@atlassian/help-center-common-util/analytics/analytics-screen';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import messages from './messages';

export interface CompleteSignupExpiredTokenScreenStatelessProps {
    isNewSignupLinkBeingSent: boolean;
    onSendNewLinkClicked: () => void;
}

export class CompleteSignupExpiredTokenScreenStateless extends React.Component<
    CompleteSignupExpiredTokenScreenStatelessProps & InjectedIntlProps
> {
    render() {
        const { intl, onSendNewLinkClicked, isNewSignupLinkBeingSent } = this.props;

        const getContent = () => (
            <NoteContent isLoading={false} isCentered>
                <FireScreenEventOnMount />
                <IconContainer>
                    <ErrorIcon />
                </IconContainer>

                <Message>{intl.formatMessage(messages.tokenExpiredmessage)}</Message>
                <ThemedButton
                    testId={`send-new-link-button${isNewSignupLinkBeingSent ? '-loading' : ''}`}
                    id="send-new-link-button"
                    isLoading={isNewSignupLinkBeingSent}
                    shouldFitContainer
                    onClick={onSendNewLinkClicked}
                    actionSubjectId="resendLinkCompletedSignUp"
                >
                    {intl.formatMessage(messages.resendSignUpLinkButton)}
                </ThemedButton>
            </NoteContent>
        );

        return <AnalyticsScreen screenName={ScreenName.COMPLETE_SIGNUP_TOKEN_EXPIRED}>{getContent()}</AnalyticsScreen>;
    }
}

export default injectIntl(CompleteSignupExpiredTokenScreenStateless);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const IconContainer = styled.div`
    width: ${gridMultiple(14).px};
    margin: 0 auto ${token('space.200', '16px')} auto;
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Message = styled.div`
    ${h600};
    margin-bottom: ${token('space.500', '40px')};
`;
